import React from "react";

export const DatePickerTrigger = React.forwardRef(
    ({value, onClick, onKeyDown}, ref) => {
        return (
            <button type="button"
                    ref={ref}
                    className={'datepicker-trigger'}
                    onClick={onClick}
                    onKeyDown={onKeyDown}>
                {value}
            </button>
        );
    }
);